export default "__VITE_ASSET__E8iwgD1t__"